module.exports = __webpack_public_path__ + "img/products_nautilius.34fa02f9.png";